import * as z from 'zod'

export const editRuleSchema = z.object({
  effectiveEnd: z
    .string()
    .nullish()
    .transform((val) => val || null),
  reference: z.string().optional(),
})

export type EditRuleSchema = z.infer<typeof editRuleSchema>
